<template>
  <div class="pb-5">
    <h2
      class="title mx-4 mt-4 mb-1 text-xs-left"
      style="font-weight:400;"
    >Cadastro de contas financeiras</h2>
    <p class="xs12 text-xs-left pl-4 pb-3">
      <span class="caption pr-2">Faça o download das planilhas de exemplo para</span>
      <v-icon small class="miniPrimary light-blue--text text--darken-4 pr-1">cloud_download</v-icon>
      <a class="caption light-blue--text text--darken-4" href="downloads/orçamento.xlsx">Orçamento</a>
      <v-icon small class="miniPrimary light-blue--text text--darken-4 pr-1 ml-3">cloud_download</v-icon>
      <a
        class="caption light-blue--text text--darken-4"
        href="downloads/realizado.xlsx"
      >Orçamento realizado</a>
    </p>
    <SearchArea :searchAccounts="searchAccounts" />
    <FinancialRegisterList :accountsList="accountsList" :editAccountLine="editAccountLine" />
    <CreateNewAccount
      :searchAccounts="searchAccounts"
      :lastData="lastData"
      :newAccountData="newAccountData"
      :newAccountFormDialog="newAccountFormDialog"
      :openDialogForm="openDialogForm"
      :closeDialogForm="closeDialogForm"
    />
  </div>
</template>

<script>
import SearchArea from "./SearchArea";
import FinancialRegisterList from "./FinancialRegisterList";
import CreateNewAccount from "./CreateNewAccount";
export default {
  components: {
    SearchArea,
    FinancialRegisterList,
    CreateNewAccount
  },
  data() {
    return {
      lastData: {},
      accountsList: [],
      newAccountData: {},
      formData: {},
      newAccountFormDialog: false
    };
  },
  methods: {
    editAccountLine(data) {
      this.openDialogForm(data);
    },
    searchAccounts(data) {
      console.log(data);
      this.lastData = { ...data };
      let dataSearch = {};
      dataSearch.params = {
        ...data
      };
      let obj = {
        url: "/api/financialAccount",
        query: dataSearch,
        method: "get"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.accountsList = response.data;
      });
    },
    openDialogForm(data) {
      this.newAccountData = {};
      if (data) {
        this.newAccountData = data;
      }
      this.newAccountFormDialog = true;
    },
    closeDialogForm() {
      this.newAccountFormDialog = this.newAccountFormDialog = false;
    },
    sendFile(data) {}
  }
};
</script>

<style>
</style>